// To prevent multiple instrument registration we have to rely on global variables
import identity from "ramda/es/identity";
const __apm_handlers__ = {};
const __apm_instrumented__ = {};
const __apm_transformers__ = {};
export const getInstrumentTypeConfig = (type)=>({
        init: ()=>{
            __apm_instrumented__[type] = true;
        },
        handlers: __apm_handlers__[type],
        transformer: __apm_transformers__[type],
        instrumented: __apm_instrumented__[type],
        pushHandler: ({ handler, transformer })=>{
            __apm_handlers__[type] = __apm_handlers__[type] || [];
            __apm_transformers__[type] = transformer;
            __apm_handlers__[type].push(handler);
            return ()=>{
                __apm_handlers__[type] = __apm_handlers__[type].filter((registeredHandler)=>registeredHandler !== handler);
                __apm_transformers__[type] = __apm_transformers__[type] !== transformer ? identity : __apm_transformers__[type];
                __apm_instrumented__[type] = __apm_handlers__[type]?.length !== 0;
            };
        }
    });
